import { Injectable } from '@angular/core';
import { AlertController, Loading, LoadingController, ToastController } from 'ionic-angular';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HelperProvider {

    public loader: Loading;

    constructor(
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        private toastCtrl: ToastController
    ) {
    }

    // Während der Ausführung des Observables die Ladeanimation anzeigen.
    // Im Fehlerfall einen Fehler-Dialog anzeigen.
    public wrapLoading(source: Observable<any>): Observable<any> {
        this.loader = this.loadingCtrl.create({
            content: 'Kommuniziere mit Server...'
        });
        this.loader.present();

        let loading = source.finally(() => {
            this.loader.dismiss();
            this.loader = null;
        });

        return this.wrapErrorHandler(loading);
    }

    public wrapErrorHandler(source: Observable<any>): Observable<any> {
        return new Observable<any>(subscriber => {
            source
                .subscribe(
                    result => { subscriber.next(result); },
                    error => {
                        console.warn(error);
                        let message = error;
                        let alert = this.alertCtrl.create({
                            title: 'Fehler',
                            subTitle: message,
                            buttons: ['Ok']
                        });
                        alert.present();
                        // don't forward error, since we showed the user here already
                        subscriber.complete();
                    },
                    () => {
                        subscriber.complete();
                    }
                );
        });
    }

    public alertMessage(title: string, message: string = null, okBtnText = 'Ok'): Observable<void> {
        return new Observable<void>(subscriber => {
            let alert = this.alertCtrl.create({
                title: title,
                message: message,
                buttons: [
                    {
                        text: okBtnText,
                        handler: () => {
                            subscriber.next();
                            subscriber.complete();
                        }
                    }
                ]
            });
            alert.present();
        });
    }

    public alertConfirm(title: string, message: string = null, okBtnText = 'Ok', cancelBtnText = 'Abbruch'): Observable<boolean> {
        return new Observable<boolean>(subscriber => {
            let alert = this.alertCtrl.create({
                title: title,
                message: message,
                buttons: [
                    {
                        text: okBtnText,
                        handler: () => {
                            subscriber.next(true);
                            subscriber.complete();
                        }
                    },
                    {
                        text: cancelBtnText,
                        handler: () => {
                            subscriber.next(false);
                            subscriber.complete();
                        }
                    }
                ]
            });
            alert.present();
        });
    }

    public toast(message: string) {
        let toast = this.toastCtrl.create({
            message: message,
            position: 'middle',
            duration: 2000
        });
        toast.present();
    }
}



// WEBPACK FOOTER //
// ./src/provider/helper-service.ts